<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Contents</p>
<p class="toc"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/chapter01">1    The Ghosts of John’s Pass</a></p>
<p class="toc1"><a href="#/chapter01#h1">John Levique</a></p>
<p class="toc1"><a href="#/chapter01#h2">Yankee Brothers in Southern Soil</a></p>
<p class="toc1"><a href="#/chapter01#h3">Eleanor Key</a></p>
<p class="toc1"><a href="#/chapter01#h4">Captain Hubbard</a></p>
<p class="toc1"><a href="#/chapter01#h5">Pirate Legends</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2    The Ghosts of St. Pete Beach</span></p>
<p class="toc1"><span href="#/chapter02#h1" title="Link target outside of Sample">Comfort and Joy</span></p>
<p class="toc1"><span href="#/chapter02#h2" title="Link target outside of Sample">Silas Dent</span></p>
<p class="toc1"><span href="#/chapter02#h3" title="Link target outside of Sample">The Castle Hotel</span></p>
<p class="toc1"><span href="#/chapter02#h4" title="Link target outside of Sample">The Hurricane Restaurant</span></p>
<p class="toc1"><span href="#/chapter02#h5" title="Link target outside of Sample">Don CeSar</span></p>
<p class="toc1"><span href="#/chapter02#h6" title="Link target outside of Sample">Snippets—Short Stories from St. Pete Beach</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3    The Ghosts of Gulfport</span></p>
<p class="toc1"><span href="#/chapter03#h1" title="Link target outside of Sample">The Peninsula</span></p>
<p class="toc1"><span href="#/chapter03#h2" title="Link target outside of Sample">Karen Gregory</span></p>
<p class="toc1"><span href="#/chapter03#h3" title="Link target outside of Sample">The Cat and the Casino</span></p>
<p class="toc1"><span href="#/chapter03#h4" title="Link target outside of Sample">The Trolley</span></p>
<p class="toc1"><span href="#/chapter03#h5" title="Link target outside of Sample">The Rolyat</span></p>
<p class="toc1"><span href="#/chapter03#h6" title="Link target outside of Sample">La Cote de Basque Winehouse</span></p>
<p class="toc1"><span href="#/chapter03#h7" title="Link target outside of Sample">Sunshine Skyway</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4    The Ghosts of Downtown St. Petersburg</span></p>
<p class="toc1"><span href="#/chapter04#h1" title="Link target outside of Sample">The Bathroom and the Museum</span></p>
<p class="toc1"><span href="#/chapter04#h2" title="Link target outside of Sample">The Vinoy</span></p>
<p class="toc1"><span href="#/chapter04#h3" title="Link target outside of Sample">The Home of Ott and Julia Whitted</span></p>
<p class="toc1"><span href="#/chapter04#h4" title="Link target outside of Sample">The Sutphin House</span></p>
<p class="toc1"><span href="#/chapter04#h5" title="Link target outside of Sample">The Coliseum Ballroom</span></p>
<p class="toc1"><span href="#/chapter04#h6" title="Link target outside of Sample">Two Flamboyant Mayors</span></p>
<p class="toc1"><span href="#/chapter04#h7" title="Link target outside of Sample">The Martha Washington Hotel</span></p>
<p class="toc1"><span href="#/chapter04#h8" title="Link target outside of Sample">Haslam’s Book Store</span></p>
<p class="toc1"><span href="#/chapter04#h9" title="Link target outside of Sample">Bed and Breakfast Stories</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5    The Ghosts of Clearwater</span></p>
<p class="toc1"><span href="#/chapter05#h1" title="Link target outside of Sample">The Belleview Biltmore</span></p>
<p class="toc1"><span href="#/chapter05#h2" title="Link target outside of Sample">Fort Harrison Hotel</span></p>
<p class="toc1"><span href="#/chapter05#h3" title="Link target outside of Sample">Safety Harbor Resort and Spa</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Selected Bibliography</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4964443a